import { Grid, Typography, Box } from "@mui/material";
import eSignSuccess from "../../assets/svg/nomine_1.png";
import caution from "../../assets/svg/nomine_2.png";

const ESignSuccess = () => {
    const updateType = localStorage.getItem('updateType')

    return (
        <Grid container justifyContent="center" spacing={3} padding={{ xs: 2, sm: 3 }}>
            <Grid item xs={12} textAlign="center">
                <Box component="img"
                    src={eSignSuccess}
                    alt="E-sign success"
                    sx={{ maxWidth: { xs: "40%", sm: "25%", md: "15%" }, height: "auto" }}
                />
            </Grid>

            <Grid item xs={12}>
                <Typography
                    sx={{
                        color: "#131E2E",
                        fontSize: { xs: "14px", sm: "16px", },
                        fontWeight: 600,
                        textAlign: "center",
                        px: { xs: 2, sm: 4 }
                    }}
                >
                    Your {updateType === 'email' ? 'Email' : 'Mobile'} change request is Initiated.
                </Typography>
            </Grid>

            <Grid item xs={12}>
                <Box display="flex" alignItems="center" justifyContent="center" gap={2} px={2}>
                    <Box component="img" src={caution} alt="Caution" sx={{ width: 30, height: 30 }} />
                    <Typography
                        sx={{
                            color: "#131E2E",
                            fontSize: { xs: "14px", sm: "16px" },
                            textAlign: "left",
                            maxWidth: "80%"
                        }}
                    >
                        We will inform you once your New {updateType === 'email' ? 'Email' : 'Mobile'} is updated. This usually takes upto 48hours. Once the change is successfully completed, you would be logged out of all active sessions. 
                    </Typography>
                </Box>
            </Grid>
        </Grid>
    );
};

export default ESignSuccess;
